import React from 'react';
import styled from 'styled-components';
import { device } from '../../styles/devices';

const Host = styled.div`
  @media ${device.tablet} {
    display: flex;
  }

  > * {
    margin-bottom: 90px;

    @media ${device.tablet} {
      margin-bottom: 0;
    }
  }

  > * {
    &:nth-child(2n) {
      margin-top: 30px;

      @media ${device.tablet} {
        margin-left: 64px;
        margin-top: 180px;
        max-width: 30%;
        flex-shrink: 0;
      }

      @media ${device.desktop} {
        margin-left: 140px;
        margin-top: 180px;
        max-width: 40%;
        flex-shrink: 1;
      }
    }
  }
`;

interface ImageLayoutProps {
  children: React.ReactNode;
}

export const ImageLayout = ({ children }: ImageLayoutProps) => {
  return <Host>{children}</Host>;
};
